const clipperCargas = [
  {
    label: 'Recepción',
    iconKey: 'files',
    items: [
      { label: 'Recepción de Cargas', to: '/cargas/recepcion', iconKey: 'files' },
      { label: 'Control de Carga Confirmada', to: '/cargas/control-carga', iconKey: 'confirmar' },
      { label: 'Control de bultos (escáner)', to: '/cargas/control-bultos', iconKey: 'confirmar' },
    ],
  },
];

export default clipperCargas;
